import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconUsers = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7m11.031-4.118a1 1 0 0 1 1.217-.72 5 5 0 0 1 0 9.687 1 1 0 0 1-.496-1.938 3 3 0 0 0 0-5.812 1 1 0 0 1-.72-1.217M7 16a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3zm10.032-1.1a1 1 0 0 1 1.218-.718A5 5 0 0 1 22 18.994V21a1 1 0 1 1-2 0v-1.997a3 3 0 0 0-2.25-2.885 1 1 0 0 1-.718-1.218"
            clipRule="evenodd"
        />
    </svg>
);
